export const TRANSACTION_CATEGORIES = [
  "II.c. FOMENTO DEPÓSITOS",
  "II.d. OUTROS DEPÓSITOS",
  "II.e. TRANSFERÊNCIAS REC/CONC",
  "II.f. APLICAÇÕES / RESGATES",
  "II.g. PAGAMENTOS",
  "II.h. DESPESAS BANCÁRIAS"
] as const;

export type TransactionCategory = typeof TRANSACTION_CATEGORIES[number];
